/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { get } from 'lodash';

// Consts
import { POLLS_COLOURS_DEFAULTS } from 'libs/services/live-stream';

// Components
import ColorPicker from 'shared/ui/components/form-components/pickers/ColorPicker.vue';

const __vue_script__ = {
    name: 'WordCloudColours',

    components: {
        ColorPicker
    },

    model: {
        prop: 'value',
        event: 'change'
    },

    props: {
        value: {
            type: Object,
            default: () => POLLS_COLOURS_DEFAULTS
        },

        label: {
            type: String,
            default: ''
        },

        hint: {
            type: String,
            default: ''
        },
    },

    data() {
        return {
            colours: Object.keys(POLLS_COLOURS_DEFAULTS),
        };
    },

    created() {
        if (!this.value || !Object.keys(this.value).length) {
            this.$emit('change', POLLS_COLOURS_DEFAULTS);
        }
    },

    methods: {
        getColour(idx) {
            return get(this.value, this.colours[idx]);
        },

        setColour(idx, colourValue) {
            if (typeof colourValue !== 'string') {
                return;
            }

            this.$emit('change', {
                ...this.value,
                [this.colours[idx]]: colourValue
            });
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "word-cloud-colours feature-dependant" }, [
    _c(
      "div",
      { staticClass: "form-group color-block" },
      [
        _vm.label || _vm.hint
          ? _c("div", { staticClass: "label-section" }, [
              _vm.label
                ? _c("h4", { staticClass: "headlines" }, [
                    _vm._v(_vm._s(_vm.$t(_vm.label))),
                  ])
                : _vm._e(),
              _vm.hint
                ? _c("small", { staticClass: "hint" }, [
                    _vm._v(_vm._s(_vm.$t(_vm.hint))),
                  ])
                : _vm._e(),
            ])
          : _vm._e(),
        _vm._l(_vm.colours, function (colour, idx) {
          return _c(
            "div",
            { key: colour, staticClass: "colours-section" },
            [
              _c(
                "validation-provider",
                { attrs: { slim: true } },
                [
                  _c("color-picker", {
                    attrs: { value: _vm.getColour(idx), name: colour },
                    on: {
                      input: function (c) {
                        return _vm.setColour(idx, c)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        }),
      ],
      2
    ),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/live-sessions/settings/WordCloudColours.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__